import { RightOutlineIcon } from '@carboncopyco/icons';
import type { TopAsset } from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';

export const RowChevron = ({ asset }: { asset: TopAsset }) => {
  return (
    <RightOutlineIcon
      size={16}
      color={
        asset.status === 'deleted' || asset.status === 'inactive'
          ? ColorHex.natural200
          : ColorHex.natural600
      }
    />
  );
};
